document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll('.servicekBtnColor').forEach(wrapper => {
    
    const button = wrapper.querySelector('a');
    if (!button || !button.textContent.trim()) return;

    const bg       = wrapper.getAttribute('service-btn-bg-color');
    const txt      = wrapper.getAttribute('service-btn-text-color');
    const hoverBg  = wrapper.getAttribute('service-btn-hover-color');
    const hoverTxt = wrapper.getAttribute('service-btn-hover-text-color');

    Object.assign(button.style, {
      backgroundColor: bg,
      color: txt,
    });

    button.addEventListener('mouseenter', () => {
      button.style.backgroundColor = hoverBg;
      button.style.color = hoverTxt;
    });
    button.addEventListener('mouseleave', () => {
      button.style.backgroundColor = bg;
      button.style.color = txt;
    });
  });
});